<script>
	import Clipboard from "svelte-clipboard";
	import SvelteMarkdown from "svelte-markdown";

	export let msg;
	export let text;
	export let showReturnHomeButton;
	export let isURL;
	export let isCompletionCode;
	export let onClose;
	export let redirectRoute;

	let copied = false;
	let copiedText = "Copy code";

	const handleClick = () => {
		onClose();
		window.location.replace(redirectRoute);
	};
</script>

<section>
	<!-- <h1>You've reached the end.</h1> -->
	<SvelteMarkdown source={msg} />

	{#if isURL}
		<p>Your completion/redirection URL is shown below.</p>
		<h4>
			<a href={text} target="_blank">{text}</a>
		</h4>
	{/if}

	{#if isCompletionCode}
		<h4>
			<strong><p>Completion code: {text}</p></strong>
		</h4>
		<Clipboard
			{text}
			let:copy
			on:copy={() => {
				copied = true;
				copiedText = "Copied!";
			}}
		>
			<button on:click|preventDefault={copy} class="copy-button"
				>{copiedText}</button
			>
		</Clipboard>
	{/if}

	{#if showReturnHomeButton}
		<button on:click|preventDefault={handleClick}>Return home</button>
	{/if}
</section>

<style>
	h1 {
		font-size: 1.3rem;
		text-align: center;
	}

	h4 {
		font-size: 1.1rem;
		text-align: center;
	}
	button {
		margin: auto;
		display: block;
	}
	p {
		text-align: center;
	}
</style>
